import { CurrentUser } from "@rossum/upcloud-costs-shared";

import { getJson, postJson } from "./http-client";

/** Starts a login by navigating to the backend, which redirects to the identity provider. */
export function login(): void {
    window.location.assign("/api/auth/login");
}

export function fetchCurrentUser(): Promise<CurrentUser> {
    return getJson<CurrentUser>("/api/auth/me");
}

export async function logout(): Promise<void> {
    const { logoutUrl } = await postJson<{ logoutUrl: string | null }>("/api/auth/logout");
    window.location.assign(logoutUrl ?? "/");
}
